import React from 'react'
import { UnstyledButton, Text } from '@chilipiper/design-system'
import { useTranslations } from '@chilipiper/locale'

interface Props {
  isOpen: boolean
  setOpen: (open: boolean) => void
}

export const InviteAdditionalGuestsToggle = ({ isOpen, setOpen }: Props) => {
  const [inviteAdditionalGuests] = useTranslations(['inviteAdditionalGuests'])
  return (
    <UnstyledButton
      data-test-id='InviteAdditionalGuests-Button'
      onClick={() => setOpen(!isOpen)}
      pt={2}
      pb={1}
    >
      <Text fontWeight={600} color='neutral-dark-40'>
        {isOpen ? '-' : '+'}
        {inviteAdditionalGuests}
      </Text>
    </UnstyledButton>
  )
}
